var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplyLeaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.75H23.25M8.08333 3.25V5.41667M18.9167 3.25V5.41667M13.4974 13.7712C12.7393 12.9272 11.4751 12.7001 10.5253 13.4731C9.5755 14.2459 9.44177 15.5383 10.1877 16.4524C10.6088 16.9685 11.6094 17.8732 12.4009 18.5632C12.7762 18.8905 12.9639 19.0542 13.1909 19.1212C13.3845 19.1782 13.6103 19.1782 13.8039 19.1212C14.0309 19.0542 14.2186 18.8905 14.594 18.5632C15.3854 17.8732 16.386 16.9685 16.8071 16.4524C17.5531 15.5383 17.4356 14.2378 16.4695 13.4731C15.5033 12.7083 14.2555 12.9272 13.4974 13.7712ZM7.21667 22.75H19.7833C20.9968 22.75 21.6036 22.75 22.067 22.5138C22.4747 22.3062 22.8062 21.9747 23.0138 21.567C23.25 21.1036 23.25 20.4968 23.25 19.2833V8.88333C23.25 7.66988 23.25 7.06316 23.0138 6.59969C22.8062 6.192 22.4747 5.86054 22.067 5.65282C21.6036 5.41667 20.9968 5.41667 19.7833 5.41667H7.21667C6.00322 5.41667 5.39649 5.41667 4.93302 5.65282C4.52533 5.86054 4.19387 6.192 3.98616 6.59969C3.75 7.06316 3.75 7.66988 3.75 8.88333V19.2833C3.75 20.4968 3.75 21.1036 3.98616 21.567C4.19387 21.9747 4.52533 22.3062 4.93302 22.5138C5.39649 22.75 6.00321 22.75 7.21667 22.75Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyLeaveIcon);
export default __webpack_public_path__ + "static/media/applyLeaveIcon.979ac8e287817f1847a2642c0330a2d9.svg";
export { ForwardRef as ReactComponent };